import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoadingService } from '../../services/loading.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-preloader',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  template: `
    <div class="preloader-container" *ngIf="isLoading$ | async">
      <div class="preloader-content">
        <div class="logo-container">
          <img src="assets/mindmaps.png" alt="Mindmaps Logo" class="mindmaps-logo">
        </div>
        <div class="spinner-container">
          <mat-spinner diameter="50"></mat-spinner>
        </div>
        <div class="loading-text">
          Loading your content...
        </div>
      </div>
    </div>
  `,
  styles: [`
    .preloader-container {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.7);
      backdrop-filter: blur(10px);
      z-index: 1000;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .preloader-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      background-color: rgba(255, 255, 255, 0.9);
      border-radius: 10px;
      padding: 2rem;
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    }

    .logo-container {
      margin-bottom: 20px;
    }

    .mindmaps-logo {
      width: 200px;
      height: auto;
    }

    .spinner-container {
      margin-bottom: 20px;
    }

    .loading-text {
      font-size: 16px;
      font-weight: 500;
      color: #333;
    }
  `]
})
export class PreloaderComponent implements OnInit {
  isLoading$: Observable<boolean>;

  constructor(private loadingService: LoadingService) {
    this.isLoading$ = this.loadingService.appLoading$;
  }

  ngOnInit(): void {}
}
